// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__V0ra-","input":"Checkbox_input__2Hw2s","iconContainer":"Checkbox_iconContainer__3mDMd","icon":"Checkbox_icon__9GL12","error":"Checkbox_error__E200m"};